import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { RichTextFormComponent } from 'src/app/patients/dashboard-page/provider-charts-tab/rich-text-form/rich-text-form.component';
import { Note } from 'src/app/calvin-emr-shared/models/note.model';
import { RichTextFormComponent as RichTextFormComponent_1 } from '../rich-text-form/rich-text-form.component';
import { ButtonDirective } from 'primeng/button';

export interface NoteDialogData {
  type: 'create' | 'edit';
  note: Note;
  forOrderSet?: boolean;
}

@Component({
  selector: 'app-note-dialog',
  templateUrl: './note-dialog.component.html',
  styleUrls: ['./note-dialog.component.scss'],
  standalone: true,
  imports: [RichTextFormComponent_1, ButtonDirective],
})
export class NoteDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('noteForm') noteForm!: RichTextFormComponent;

  data: NoteDialogData;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private cdRef: ChangeDetectorRef
  ) {
    this.data = config.data;
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
  }

  closeDialog(): void {
    this.ref.close();
  }

  /**
   * Submit the form and send the form's data to the patient component
   */
  onSubmit() {
    const note = this.noteForm.getNoteFromForm({ partOfOrderSet: this.data.forOrderSet || false });
    this.ref.close(note);
  }

  get btnLabel() {
    return this.data.type === 'create' ? 'Create' : 'Update';
  }

  get isFormValid() {
    if (this.noteForm !== undefined && this.noteForm !== null) {
      return this.noteForm.form.valid;
    }
    return false;
  }
}
